import { createContext, useContext } from 'react';

import type { GetCurrentEmployeeQuery } from '@/common/graphql';

export type CurrentEmployeeContextType = {
  loading: boolean;
  currentEmployee: GetCurrentEmployeeQuery['currentEmployee'] | null;
  setCurrentEmployee: (currentEmployee: GetCurrentEmployeeQuery['currentEmployee']) => void;
};

export const CurrentEmployeeContext = createContext<CurrentEmployeeContextType>({
  loading: true,
  currentEmployee: null,
  setCurrentEmployee: () => {},
});

export const useCurrentEmployeeContext = (): CurrentEmployeeContextType => useContext(CurrentEmployeeContext);
